/**
 * @file list_store.js
 * @description 帖子列表页
 */

import {get, post} from '@/utils/decorate/request';
import {Url} from '@/utils/api.js';
import toast from '@/utils/decorate/toast';

export default {
    state: {
        issueInfo: {
            tagId: 17,
            process: 'ALL',
            pageNo: 1
        },
        notIssueInfo: {
            moduleId: 3,
            pageNo: 1
        },
        listData: {}
    },
    mutations: {
        clearListData(state) {
            state.listData = {};
        },
        setListData(state, data) {
            state.listData = data;
        },
        setConcatListData(state, data) {
            state.listData.topicList = state.listData.topicList.concat(data.topicList);
            state.listData.pageInfo = data.pageInfo;
        },
        setTagId(state, tagId) {
            state.issueInfo.tagId = tagId;
        },
        setPageNo(state, pageNo) {
            state.issueInfo.pageNo = pageNo;
        },
        setProcess(state, process) {
            state.issueInfo.process = process;
        },
        setBoardId(state, moduleId) {
            state.notIssueInfo.moduleId = moduleId;
        },
        setListPageNo(state, pageNo) {
            state.notIssueInfo.pageNo = pageNo;
        }
    },
    actions: {
        // 获取帖子 List
        getTopicList({state, commit, rootState}, {params, query = {}, loadMore = false}) {
            let requestQuery = Object.assign({}, rootState.common.filterQuery, query);
            if (params.moduleid) {
                requestQuery.boardId = params.moduleid;
            }
            let url = Url.topicListUrl;
            if (loadMore && state.listData.pageInfo) {
                requestQuery.pageNo = +state.listData.pageInfo.pageNo + 1;
            }
            return get(url, {...requestQuery})
                .then(data => {
                    if (loadMore) {
                        commit('setConcatListData', data);
                    }
                    else {
                        commit('setListData', data);
                    }
                })
                .catch(errmsg => toast.error(errmsg));
        },
        // 管理员删除帖子
        deleteOperation({commit}, {topicId}) {
            let url = Url.delTopicUrl;
            return post(url, {topicId})
                .then(data => {
                    toast.success('删除成功');
                })
                .catch(errmsg => toast.error(errmsg));
        },
        // 删除帖子回复
        delReplyOperation({commit}, {replyId}) {
            let url = Url.delReplyUrl;
            return post(url, {replyId})
                .then(data => {
                    toast.success('删除成功');
                })
                .catch(errmsg => toast.error(errmsg));
        },
        managerOperation({dispatch}, {type, topicId, enable, replyId}) {
            return dispatch(type + 'Operation', {topicId, enable, replyId});
        }
    }
};
